// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3879j","fullView":"styles_fullView__3a4ZI"};